export function filterMenuLinks(links, { accountSelected, can }) {
    return links
        .map((link) => {
            if (link.children) {
                const visible_children = link.children.filter((child) => {
                    if (accountSelected && !child.filtered) {
                        return false;
                    }
                    if (!Array.isArray(child.scope) || child.scope.length === 0) {
                        return true;
                    }
                    return can(child.scope, child.bypassPositions);
                });
                if (visible_children.length === 0) {
                    return null;
                }
                return {
                    ...link,
                    visibleChildren: visible_children,
                };
            }

            if (accountSelected && !link.filtered && !link.pinned) {
                return null;
            }

            const allowed = link.scope ? can(link.scope, link.bypassPositions) : true;
            if (!allowed) {
                return null;
            }

            return {
                ...link,
                visibleChildren: [],
            };
        })
        .filter((link) => link !== null);
}
